import { Steps, type StepsProps } from 'antd';
import type { ProdutoEstoqueRegistro } from '@/features/produto/util/estoque';
import type { Produto } from '../../types/Produto';
import type { ProdutoLote } from '../../types/ProdutoLote';
import type { ProdutoPacoteBarra } from '../../types/ProdutoPacoteBarra';
import { getProdutoSelectEstoqueDescricao, produtoTemEtapaLote } from './produtoSelectUtil';

export enum Step {
    Produto = 0,
    PacoteBarra = 1,
    Lote = 2,
    LocalEstoque = 3,
}

export function ProdutoSelectModalSteps({
    step,
    produto,
    pacoteBarra,
    lote,
    localEstoque,
    showLocalEstoque,
    onChange,
}: {
    showLocalEstoque: boolean;
    step: Step;
    produto: Produto;
    pacoteBarra: ProdutoPacoteBarra | null;
    lote: ProdutoLote | null;
    localEstoque?: ProdutoEstoqueRegistro | null;
    onChange: (step: Step) => void;
}) {
    const temPacote = !!produto.produto_pacote_barra?.length;
    const temLote = produtoTemEtapaLote(produto);

    const etapas: (NonNullable<StepsProps['items']>[number] & { key: Step })[] = [
        {
            content: produto.pro_descricao,
            key: Step.Produto,
            title: 'Produto',
        },
    ];

    if (temPacote) {
        etapas.push({
            content: pacoteBarra?.pcb_descricao,
            key: Step.PacoteBarra,
            title: 'Pacote / Barra',
        });
    }

    if (temLote) {
        etapas.push({
            content: lote?.prl_chave,
            disabled: step < Step.Lote,
            key: Step.Lote,
            title: 'Lote',
        });
    }

    if (showLocalEstoque) {
        etapas.push({
            content: localEstoque ? getProdutoSelectEstoqueDescricao(localEstoque) : undefined,
            disabled: step < Step.LocalEstoque,
            key: Step.LocalEstoque,
            title: 'Local de estoque',
        });
    }

    return (
        <Steps
            className='mb-4'
            current={etapas.findIndex((etapa) => etapa.key === step)}
            items={etapas}
            onChange={(index) => {
                const etapa = etapas[index];
                if (etapa && !etapa.disabled && etapa.key !== Step.LocalEstoque) {
                    onChange(etapa.key);
                }
            }}
            size='small'
        />
    );
}
